import React from "react";
import "./footer.css";

const Footer = () => {
  return (
    <footer
      className="text-dark py-4"
      style={{ borderTop: "1px solid #1d2c79" }}
    >
      <div className="container text-center">
        {/* Partnerships Section */}
        <div className="row">
          <div className="col-xl-12 col-sm-12 justify-content-center px-5">
            <div>
              <h3 className="text-white">BlockAgent</h3>
              <div style={{textAlign:"left", paddingLeft:"30px"}} className=" mt-3 mb-3">
                BlockAgent is a Layer 1 proof of work consensus
                mechanism that evolves the crypto sphere with a cutting-edge
                Directed Acyclic Graph structure building on the foundations of
                Bitcoin.
              </div>
            </div>
          </div>
        </div>
        <h5 className="fw-bold text-white">Partnerships</h5>

        {/* Social Media Icons */}
        <div className="mb-3 mt-3">
          <a href="#" className="mx-2 text-dark fs-4">
            <i className="fab fa-facebook"></i>
          </a>
          <a href="#" className="mx-2 text-dark fs-4">
            <i className="fab fa-x-twitter"></i>
          </a>
          <a href="#" className="mx-2 text-dark fs-4">
            <i className="fab fa-telegram"></i>
          </a>
          <a href="#" className="mx-2 text-dark fs-4">
            <i className="fab fa-youtube"></i>
          </a>
          <a href="#" className="mx-2 text-dark fs-4">
            <i className="fab fa-instagram"></i>
          </a>
          <a href="#" className="mx-2 text-dark fs-4">
            <i className="fab fa-discord"></i>
          </a>
          <a href="#" className="mx-2 text-dark fs-4">
            <i className="fab fa-linkedin"></i>
          </a>
        </div>

        {/* Sitemap Links */}
        <div className="row justify-content-center">
          <div className="col-xl-6 col-sm-12">
            <ul className="list-unstyled">
              <li>
                <a href="#welcome_cryptonic_06" className="text-dark fw-bold">
                  HOME
                </a>
              </li>
              <li>
                <a href="#about_cryptonic_06" className="text-dark fw-bold">
                  ABOUT
                </a>
              </li>
              <li>
                <a href="#token_sale_06" className="text-dark fw-bold">
                  ECOSYSTEM
                </a>
              </li>
            </ul>
          </div>
          <div className="col-xl-6 col-sm-12 mob-style-footer">
            <ul className="list-unstyled">
              <li>
                <a href="/blockagent-ai.pdf" className="text-dark fw-bold">
                  WHITEPAPER
                </a>
              </li>
              <li>
                <a href="#roadmap_06" className="text-dark fw-bold">
                  ROADMAP
                </a>
              </li>
              <li>
                <a href="#contact_06" className="text-dark fw-bold">
                  Join Us
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
